export default "__VITE_PUBLIC_ASSET__5fa82ea8__"